// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
.page-container {
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  row-gap: calc(var(--spacing, 0.25rem) * 2.5);
  &:not(.page-container *, .modal-dialog *) {
    height: calc(100dvh - 65px) !important;
  }
  .page-title {
    font-family: Roboto;
  }
  page-controls, page-content {
    display: contents;
  }
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/container/page-container/page-container.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACEA;EACkB,aAAI;EAAoB,YAAM;EAArC,WAAM;EAAM,sBAAQ;EAAC,4CAAS;EAErC;IACI,sCAAuC;EAC1C;EAED;IACI,mBAAoB;EACvB;EAED;IACW,iBAAQ;EAClB;AACJ","sourcesContent":[null,"@reference '../../../../assets/css/main.css';\r\n\r\n.page-container {\r\n    @apply w-full flex flex-col gap-y-2.5 h-full;\r\n\r\n    &:not(.page-container *, .modal-dialog *) {\r\n        height: calc(100dvh - 65px) !important;\r\n    }\r\n\r\n    .page-title {\r\n        font-family: Roboto;\r\n    }\r\n\r\n    page-controls, page-content {\r\n        @apply contents;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
